module.exports = __webpack_public_path__ + "static/img/banner2.d891843.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner2.jpg
// module id = YdqA
// module chunks = 9